@if (!loading) {
  <div class="row mx-0 mb-2">
    <div class="col-6 px-0 text-start">
      <app-office-nav
        [currentSection]="currentSection"
        (sectionClick)="onSectionClick($event)"
        [office]="office" />
    </div>
    <div class="col-6 text-end">
      <a class="nav-link" routerLink="/capture-admin/offices/{{ office.id }}/audits" target="_blank">
        View Change Log
      </a>
    </div>
  </div>
  <div class="page-container">
    @if (!editing) {
      <app-office-header
        [office]="office"
        (editDetails)="onEditDetails()"
        />
    }
    @if (editing) {
      <app-office-header-edit
        [office]="office"
        (canceled)="onEditDetailsCancel()"
        (updated)="onUpdatedDetails()"
        />
    }
    @if (currentSection === 'officeDetails') {
      <div>
        <app-office-detail [office]="office" />
      </div>
    }
  </div>
  @if (currentSection === 'communications') {
    <div>
      <app-office-communications [office]="office" />
    </div>
  }
} @else {
  <mat-spinner />
}
